module.exports = __webpack_public_path__ + "media/images/shark/Tilden-p-500-e46238ec125ac9d07c37687e883c6f9f.jpeg";